import React from "react";
import { Routes, Route } from 'react-router-dom';

import Dashboard from './../Pages/Marketing/Dashboard';
import Campaigns from './../Pages/Marketing/Campaigns/CampaignsList';
import LeadReport from './../Pages/Marketing/Report/LeadReport';

const Marketing = [
    {
        path: "marketing/dashboard", 
        element: <Dashboard />,
    },
    {
        path: "marketing/campaigns", 
        element: <Campaigns />,
    },
    {
        path: "marketing/leadreport", 
        element: <LeadReport />,
    },
];

export default Marketing;